import { Component } from '@angular/core';

@Component({
    templateUrl: './related-card-personalize-page.component.html',
    styleUrls: ['./related-card-personalize-page.component.scss']
})
export class RelatedCardPersonalizePageComponent {}
